import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CommandSearch } from "@/components/search/CommandSearch";

export function SiteLayout() {
  const [searchOpen, setSearchOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    if (loc.hash) {
      const id = loc.hash.slice(1);
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      const t = setTimeout(scroll, 250);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [loc.pathname, loc.hash]);

  useEffect(() => {
    const onKey = (e) => {
      const tag = (e.target.tagName || "").toLowerCase();
      const editable = e.target.isContentEditable;
      if (e.key === "/" && !["input", "textarea", "select"].includes(tag) && !editable) {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <a href="#main" className="skip-link">Skip to content</a>
      <Header onOpenSearch={() => setSearchOpen(true)} />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CommandSearch open={searchOpen} setOpen={setSearchOpen} />
    </div>
  );
}
